import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export interface ExamData {
  stage: string;
  lastRegistrationAt: string;
  examAttemptAt: string;
  expectedResultAt: string;
}

// get the  month name from a date string
export const getMonthName = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString('default', { month: 'long' });
};

/**
 * Formats a date string into DD/MM/YYYY format
 * @param dateString - Input date string that can be parsed by Date constructor
 * @returns Formatted date string in DD/MM/YYYY format
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function createSlug(title: string): string {
  return (
    title
      .toLowerCase()
      // Replace spaces and special punctuation with hyphens
      .replaceAll(/[\s\p{P}]+/gu, '-')
      // Remove hyphens from start and end
      .replaceAll(/^-+|-+$/g, '')
  );
}

export function isBatchExpired(admissionEndDate: string | Date): boolean {
  const today = new Date();
  const toDate = new Date(admissionEndDate);
  const daysLeft = Math.ceil((toDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  return daysLeft <= 0;
}

export const parseYouTubeVideoId = (url: URL) => {
    // Normal Link
    if (url.searchParams.has('v')) {
        return url.searchParams.get('v') ?? null;
    }

    // Clear all search params.
    url.search = '';

    // Shortened, Live, or Embedded Link
    if (url.host === 'youtu.be' || url.pathname.startsWith('/live') || url.pathname.startsWith('/embed')) {
        return url.pathname.split('/').at(-1) ?? null;
    }

    return null
};